import AccountCircle from '@mui/icons-material/AccountCircle';
import Task from '@mui/icons-material/Task';
import Today from '@mui/icons-material/Today';
import {
  Avatar,
  AvatarGroup,
  Box,
  Divider,
  Icon,
  Tooltip,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { uniqBy } from 'lodash';
import PropTypes from 'prop-types';
import { Views } from 'react-big-calendar';
import TagList from '../../../../../TagList';

const AvatarGroupStyled = styled(AvatarGroup)({
  '& .MuiAvatarGroup-avatar': {
    width: 24,
    height: 24,
    fontSize: 14,
    border: 'none',
  },
});

const Event = ({ event }) => (
  <Tooltip
    title={`${event.title}${event.description
      ? ` - ${event.description}`
      : ''}`}
  >
    <Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          height: '18px',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            height: '18px',
          }}
        >
          {event.eventTask
            ? (
              <Today
                sx={{
                  height: 16,
                  width: 16,
                }}
              />
            )
            : (
              <Task
                sx={{
                  height: 16,
                  width: 16,
                }}
              />
            )}
          <Box
            sx={{
              display: 'flex',
              alignItem: 'center',
            }}
          >
            <Typography
              variant="caption"
              noWrap
              sx={[{
                fontSize: 14,
                ml: 0.5,
              }, event.view === Views.DAY
                ? { width: 150 }
                : { width: 100 }]}
            >{event.title}
            </Typography>
            {(event.view && event.view === Views.DAY) && <TagList disableGutters tags={event.horseTags} />}
          </Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            alignItem: 'center',
          }}
        >
          {
            event.customStatus && (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  height: '18px',
                  ml: 1,
                }}
              >
                <Icon
                  sx={{ fontSize: '1rem' }}
                >{event.customStatus.icon}
                </Icon>
                <Typography
                  variant="caption"
                  noWrap
                  sx={{
                    fontSize: 14,
                    ml: 0.5,
                    lineHeight: '16px',
                  }}
                >
                  {event.customStatus.name}
                </Typography>
              </Box>
            )
          }
          <AvatarGroupStyled
            sx={{
              ml: 1,
              width: 70,
            }}
            space={-2}
            _avatar={{ size: 'xs' }}
            max={4}
            total={uniqBy(event.participants, 'userFullName').length}
          >
            {(uniqBy(event.participants, 'userFullName').map((assignment) => (
              assignment.avatar
                ? (
                  <Avatar
                    sx={{
                      width: 24,
                      height: 24,
                      border: 'none',
                    }}
                    src={assignment.avatar}
                    key={`${event.id}}-${assignment.auth0UserId}`}
                  />
                )
                : (
                  <Avatar
                    sx={{
                      width: 24,
                      height: 24,
                      border: 'none',
                    }}
                    key={`${event.id}-${assignment.userFullName}`}
                    alt={assignment.userFullName}
                  >
                    <AccountCircle />
                  </Avatar>
                )
            ))
            )}
          </AvatarGroupStyled>
        </Box>
      </Box>

      {
        event.description && (
          <Divider
            sx={{
              backgroundColor: 'white',
              my: 0.5,
            }}
          />
        )
      }
      {
        event.description && (
          <Box
            sx={{
              display: 'flex',
              alignItem: 'center',
            }}
          >
            <Typography
              variant="caption"
              sx={{
                fontSize: 12,
                lineHeight: '14px',
              }}
            >{event.description}
            </Typography>
          </Box>
        )
      }
    </Box>
  </Tooltip>
)

export default Event;

Event.propTypes = { event: PropTypes.object.isRequired }
